import { StyledModal } from '@app/components/modal/Modal';
import type { Location } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { LocationForm, type LocationFormPayload } from './LocationForm';
import useLocationActions from '@app/hooks/locations/useLocationActions';
import useLocation from '@app/hooks/locations/useLocation';

export type LocationEditModalProps = ModalProps & {
    title?: string;
    data?: Location;
};

export const LocationEditModal = ({
    title = 'Edit Admin Location',
    data,
    onOk,
    ...props
}: LocationEditModalProps) => {
    const { editLocation } = useLocationActions();
    // Fetch the single location (includes `config`) only while open
    const { data: locationData } = useLocation({ id: props.open ? (data?.id ?? '') : '' });
    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    const handleSubmit = (values: LocationFormPayload) => {
        if (data) {
            const formData = { ...values, id: data.id };
            editLocation.mutate(formData, {
                onSuccess: () => {
                    if (onOk) {
                        onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                    }
                },
            });
        }
    };

    return (
        <StyledModal
            title={title}
            mask={{ closable: false }}
            width={680}
            footer={null}
            className="modal-body-scroll"
            {...props}>
            <LocationForm
                id="admin-location-edit"
                data={locationData ?? data}
                isEdit={true}
                onCancel={props.onCancel}
                loading={editLocation.isPending}
                onSubmit={handleSubmit}
            />
        </StyledModal>
    );
};
